import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppFooter from "../components/AppFooter";

const MasterPrivacyPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "MASTER PRIVACY POLICY",
      content: `Effective Date: 1.02.2026

Welcome to AICA HEALTH (“AICA”, “we”, “our”, or “us”).

This Privacy Policy explains how AICA collects, processes, stores, transfers, and protects personal data across all platforms including web, apps, APIs, and AI systems.`,
    },
    {
      title: "Data We Collect",
      content: `We may collect demographic data, biometric signals, physiological data, device data, usage data, symptom inputs, and healthcare interaction data.`,
    },
    {
      title: "Purpose of Use",
      content: `Data is used for preventive healthcare insights, AI analysis, wellness tracking, system improvement, and compliance.`,
    },
    {
      title: "Data Sharing",
      content: `We share data only with authorized healthcare providers, enterprise clients, and regulated service providers. We do not sell personal data.`,
    },
    {
      title: "Security",
      content: `We use encryption, authentication, and monitoring systems. However, no system is 100% secure.`,
    },
    {
      title: "User Rights",
      content: `Users can access, modify, or request deletion of their data subject to applicable law.`,
    },
    {
      title: "Contact",
      content: `AICA HEALTH TECH Pvt Ltd
Email: a@aicahealth.com
New Delhi, India`,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 relative overflow-hidden text-slate-800">

      {/* Soft background blur */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-cyan-200/30 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-200/30 blur-3xl rounded-full"></div>

      {/* Container */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-block px-4 py-1 rounded-full bg-white border border-slate-200 text-slate-600 text-sm shadow-sm">
            AICA HEALTH POLICY
          </div>

          <h1 className="mt-5 text-4xl sm:text-5xl font-bold text-slate-800">
            MASTER Privacy Policy
          </h1>

          <p className="mt-3 text-slate-500 text-sm sm:text-base max-w-2xl mx-auto">
            Master privacy framework explaining how we handle, store, and protect your data.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-6">

          {sections.map((sec, i) => (
            <div
              key={i}
              className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition"
            >
              <h2 className="text-lg sm:text-xl font-semibold text-slate-800 mb-3">
                {sec.title}
              </h2>

              <p className="text-slate-600 whitespace-pre-line leading-relaxed text-sm sm:text-base">
                {sec.content}
              </p>
            </div>
          ))}

        </div>

        {/* Footer */}
         <div className="mt-10 flex justify-center">

          <button
            onClick={() => navigate("/")}
            className="
            flex items-center gap-2
            px-6 py-3
            rounded-2xl
            bg-gradient-to-r from-cyan-500 to-blue-500
            text-white
            font-semibold
            shadow-lg
            hover:scale-105
            hover:shadow-cyan-300/50
            transition-all duration-300
          "
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

        </div>

      </div>

      {/* FOOTER */}
      {/* <AppFooter /> */}
    </div>
  );
};

export default MasterPrivacyPolicy;